import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import ExEnv from 'exenv';
import { persistToSessionStorage } from '@nike/ux-tread-web-storage';
import { CLEAR_PARTNER_CART_ERRORS, GET_PREORDER_FAILURE, GET_PREORDER_SUCCESS, PARTNER_CART_INITIAL_STATE, PARTNER_CART_STATE_KEY } from './constants';

/**
 *
 */
export function partnerCartReducer() {
  var _action$payload;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PARTNER_CART_INITIAL_STATE;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case GET_PREORDER_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        inFlight: false
      });
    case GET_PREORDER_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.errors) || [],
        inFlight: false
      });
    case CLEAR_PARTNER_CART_ERRORS:
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: []
      });
    default:
      return state;
  }
}

/**
 *
 */
export function addPartnerCartReducer(options) {
  return _defineProperty({}, PARTNER_CART_STATE_KEY, ExEnv.canUseDOM && persistToSessionStorage(PARTNER_CART_STATE_KEY, partnerCartReducer, _objectSpread({
    blacklist: ['inFlight'].concat(_toConsumableArray((options === null || options === void 0 ? void 0 : options.blacklist) || []))
  }, options)));
}